/* Base Layout
Author: Maxwell Levene @maxlevene920- Ellmarr
Date: 04/30/2025
Description: Supabase client configuration and initialization. Sets up database
connection and provides the main entry point for Supabase interactions.
*/

import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://sxqqdksttwvvklgiyybi.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN4cXFka3N0dHd2dmtsZ2l5eWJpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQzMzI5NjMsImV4cCI6MjA1OTkwODk2M30.HCxch4Wn0MVgC1MDpTWjcDzoKS4fAEppvCFz7ffC07Y";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});

// Helper function for admin functions when auth is required
export const getAuthHeaders = async () => {
  const session = await supabase.auth.getSession();
  return {
    apikey: SUPABASE_PUBLISHABLE_KEY,
    Authorization: `Bearer ${session.data.session?.access_token || ''}`,
  };
};
